module.exports = __webpack_public_path__ + "static/media/vijay s.fca87030.jpg";